import React, { FC } from 'react';
import styled from 'styled-components';
import DisplayValueIfExist from '@tools/ui/components/common/DisplayValueIfExist';
import {
  convertNumberToCurrencyString,
  defaultCurrency
} from '@tools/ui-utils/currency.util';

const AdditionalAmount = styled.a`
  color: green;
`;

type IProps = {
  amount?: string | number | null;
  additionalAmount?: string | number | null;
  currency?: string;
};

const AmountWithCurrency: FC<React.PropsWithChildren<IProps>> = ({
  amount,
  additionalAmount,
  currency = defaultCurrency
}) => {
  const additionalAmountComponent = additionalAmount && (
    <AdditionalAmount>
      ({convertNumberToCurrencyString(Number(additionalAmount), currency)})
    </AdditionalAmount>
  );
  return (
    <DisplayValueIfExist value={amount}>
      <>
        {convertNumberToCurrencyString(Number(amount), currency)}{' '}
        {additionalAmountComponent}
      </>
    </DisplayValueIfExist>
  );
};

export default AmountWithCurrency;
